<template>
  <v-pagination
    v-model="pagination.current"
    :length="pagination.pages"
    :total-visible="10"
    @input="$emit('get-page', pagination.current)"
    class="mt-4"
  />
</template>

<script>
export default {
  name: "pagination-module",
  props: {
    pagination: {
      type: Object,
      required: true,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
$main-color: #09194f;
.pagination {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  .page,
  .prev,
  .next,
  .first,
  .last {
    height: 28px;
    width: 28px;
    text-align: center;
    padding: 4px 4px;
    border: 1px solid $main-color;
    display: block;
    background-color: $main-color;
    color: white;
    a {
      color: white;
    }
  }
  .page {
    margin: 0 0.25rem;
    &:first-of-type {
      margin-left: auto;
    }
    &:last-of-type {
      margin-right: auto;
    }
  }
  .page.current {
    background-color: white;
    color: $main-color;
  }
  .prev {
    margin-right: auto;
  }
  .next {
    margin-left: auto;
  }
  .first {
    margin-right: 0.5rem;
  }
  .last {
    margin-left: 0.5rem;
  }
}
</style>
